import React from "react";
import PropTypes from "prop-types";
import styles from "./custom-button.module.css";

const CustomButton = ({
  text,
  onClick,
  className = "",
  style = {},
  type = "button",
  disabled = false,
  ...rest
}) => {
  if (!text) return null;

  return (
    <button
      className={`${styles.customButton} ${className}`}
      onClick={onClick}
      style={style}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {text}
    </button>
  );
};

CustomButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  disabled: PropTypes.bool,
};

export default CustomButton;
